import React, { useEffect, useState, useMemo } from 'react';

import { DataGrid, Column, type DataGridTypes } from 'devextreme-react/data-grid';

import PortalApi from '../../api/PortalApi';

import DashboardComponentDto from '../../classes/dtos/portalmodule/DashboardComponentDto';

interface PortalDashboardTemplateProps extends DataGridTypes.MasterDetailTemplateData {
}

const componentTypeLabel = (type: number) => type === 0 ? "Graph" : "Table";

const calculateTypeDisplayValue = (rowData: DashboardComponentDto) => componentTypeLabel(rowData.Type);

const PortalDashboardTemplate = (props: PortalDashboardTemplateProps) => {
    const [components, setComponents] = useState<DashboardComponentDto[] | null>(null);

    useEffect(() => {
        PortalApi.GetDashboardAsync(props.data.key).then((e) => {
            setComponents(e.Result.Components);
        });
    }, [props.data.key]);

    // La grille ne doit recevoir une nouvelle reference de dataSource que lorsque les donnees
    // changent reellement : sinon chaque rendu React reconfigure le widget DevExtreme.
    const gridDataSource = useMemo(() => components ?? [], [components]);

    return (
        <React.Fragment>
            <DataGrid
                dataSource={gridDataSource}
                showBorders={true}
                columnAutoWidth={true}>
                <Column caption="Name" dataField="Name" />
                <Column caption="Type" dataField="Type" calculateDisplayValue={calculateTypeDisplayValue} />
            </DataGrid>
        </React.Fragment>
    );
};

export default PortalDashboardTemplate;
